let CryptoJS = require('crypto-js')

const key = '$OlIn6Sq9H9qLz1ZumnlP&gX$J^n5yd%^NfgYOVS@C^uyTGCi4#NJN6!ILs2acgJgMX8Gmj5VfproZIoSPG#jRWJZI^^^RRM9&v'

function getKey(key) {
  //真正的key
  return CryptoJS.SHA1(CryptoJS.SHA1(key)).toString().substring(0, 32)
}

export  function encrypt(data) {
  let realkey = CryptoJS.enc.Hex.parse(getKey(key))
  // Encrypt
  const cipher = CryptoJS.AES.encrypt(data, realkey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  let ciphertext = cipher.toString() //128 bits 会转成 base64编码串
  return ciphertext
}
